
  import { defineComponent } from 'vue';

  import StatisticsTabs from './StatisticsTabs.vue';

  export default defineComponent({
    components: {
      StatisticsTabs,
    },
    name: 'StatisticsViewsCountTabs',
  });
